import { useState } from "react";
import styles from "./navigation-bar.module.css";
import { MainAppMenu } from "./main-app-menu/main-app-menu";
import { NavigationBarCheckoutButton } from "./navigation-bar-checkout-button";
import { usePaths } from "BEDROCK/paths";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";

interface NavigationBarProps {}

export const NavigationBar = (props: NavigationBarProps) => {
  return (
    <div className={styles.container}>
      <LeadingContent />
      <TrailingContent />
    </div>
  );
};

const LeadingContent = () => {
  return <div className={styles.leadingContent}>title</div>;
};

const TrailingContent = () => {
  const { checkout: checkoutPath, navigateTo } = usePaths();
  const { checkout } = useCheckout();

  return (
    <div className={styles.trailingContent}>
      <NavigationBarCheckoutButton
        numberOfItems={checkout.items.length}
        onClick={() => {
          navigateTo(checkoutPath);
        }}
      />
      <MainAppMenu />
    </div>
  );
};
